// 新账号白名单请求接口
// https://iwiki.woa.com/pages/viewpage.action?pageId=1564466539

import { isPrivate } from 'src/config/private';
import Gateway from 'src/utils/Gateway';

const cacheData = {};
const keyLoading = {};
const keyResolveTaskArr = {};

function handleResolveTask(k, res) {
    if (keyResolveTaskArr[k]) {
        keyResolveTaskArr[k].forEach((resolve) => {
            resolve(res);
        });
    }
}

function getInner(key) {
    const base64Key = window.btoa(key);
    return new Promise((resolve) => {
        if (typeof cacheData[key] !== 'undefined') {
            resolve(cacheData[key]);
            return;
        }

        if (keyResolveTaskArr[key]) {
            keyResolveTaskArr[key].push(resolve);
        } else {
            keyResolveTaskArr[key] = [resolve];
        }

        if (keyLoading[key]) {
            return;
        }

        keyLoading[key] = true;
        Gateway.post('/v1/interface/inner/txplus_230230', {
            bytes_item_key: [base64Key],
        })
            .then((data) => {
                const { rpt_msg_conf_item_list: rptList } = data || {};
                const { bytes_conf_value: bytesConfValue } = (rptList && rptList[0]) || {};

                let isInWhiteList = false;
                // "MQ=="是"1"的base64
                if (bytesConfValue === 'MQ==') {
                    isInWhiteList = true;
                }
                handleResolveTask(key, isInWhiteList);
                cacheData[key] = isInWhiteList;
                keyLoading[key] = false;
            })
            .catch(() => {
                handleResolveTask(key, false);
                keyLoading[key] = false;
            });
    });
}

export function isInAccountMark() {
    if (isPrivate) {
        return Promise.resolve(true);
    }

    return getInner('qd_account_mark');
}

export function isInAccountComplete() {
    if (isPrivate) {
        return Promise.resolve(true);
    }

    return getInner('qd_account_complete');
}
